import { __rest } from "tslib";
export const refineModelForRequest = (values) => {
    const { dateCreated, dateModified, createdByEmail, modifiedByEmail } = values, model = __rest(values, ["dateCreated", "dateModified", "createdByEmail", "modifiedByEmail"]);
    return model;
};
export default refineModelForRequest;
